//Entra Auth configuration
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: '61c49f1c-d73a-48d3-95f4-cd9013ea9a40', // This is the ONLY mandatory field that you need to supply. This is the ApplicationID from Entra External ID.
    authority: 'https://dgcustomers.ciamlogin.com/dgcustomers.onmicrosoft.com', // Replace the placeholder with your tenant subdomain
    redirectUri: 'https://dashboard.degarmo.com/auth-callback', // Points to window.location.origin by default. You must register this URI on Microsoft Entra admin center/App Registration.
    postLogoutRedirectUri: 'https://dashboard.degarmo.com/pglogin', // Points to window.location.origin by default.
    knownAuthorities: ['dgcustomers.ciamlogin.com'], // You can specify multiple known authorities here.
    OIDCOptions: {
      defaultScopes: [],
    },
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    // If you set this to "true", you must also set the cacheLocation to "localStorage" or "sessionStorage"
  },
  /*system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },*/
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [],
};
